export default function PageScaler () {
  const container = document.querySelector('#page-scaler')
  const body = document.querySelector('body')

  if (!container) {
    return
  }

  const viewportWidth = getViewportWidth()

  let booted = false
  let savedStyle = {}
  let scaleMultiplier = window.innerWidth / viewportWidth

  function boot () {
    if (document.body.clientWidth >= viewportWidth) {
      // The device is already scaling natively
      function recheck () {
        window.removeEventListener('resize', recheck, false)
        boot()
      }

      window.addEventListener('resize', recheck, false)
      return
    }

    rescale()

    if (booted === false) {
      body.style.overflowX = 'hidden'

      // Possible extra optimization:
      // body.style.willChange = 'transform'

      container.style.transformOrigin = '0 0'

      window.addEventListener('resize', resize, true)
      window.dispatchEvent(new Event('resize'))

      booted = true
    }
  }

  function getViewportWidth () {
    const viewportParams = {}

    document.querySelector('meta[name=viewport]').content
      .split(',')
      .map(function (prop) {
        return prop.trim().split('=')
      })
      .forEach(function (prop) {
        viewportParams[prop[0]] = prop[1]
      })

    let width = parseInt(viewportParams.width)

    if (isNaN(width)) {
      width = 1600
    }

    return width
  }

  function rescale () {
    container.style.width = viewportWidth + 'px'
    container.style.height = '100vh'
    container.style.position = 'static'

    function finishUp () {
      if (document.readyState === 'complete') {
        container.style.position = 'absolute'
        container.style.overflow = 'hidden'
        window.dispatchEvent(new Event('resize'))
      }
    }

    finishUp()
    window.document.addEventListener('readystatechange', finishUp, false)
  }

  function resize () {
    if (document.body.clientWidth >= viewportWidth) {
      if (container.style.width) {
        // Save style
        savedStyle = {
          width: container.style.width,
          position: container.style.position,
          overflow: container.style.overflow,
          transformOrigin: container.style.transformOrigin
        }
      }

      container.style = {}
      return
    }

    const originalScroll = window.scrollY / scaleMultiplier
    scaleMultiplier = window.innerWidth / viewportWidth

    if (!container.style.width) {
      // Load style
      Object.keys(savedStyle).forEach(function (key) {
        container.style[key] = savedStyle[key]
      })
    }

    container.style.transform = `scale(${scaleMultiplier})`

    window.scrollTo(window.scrollX, originalScroll * scaleMultiplier)
  }

  boot()
}
